import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'zn-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './zn-button.html',
  styleUrls: ['./zn-button.scss'],
})
export class ZnButton {
  label = input<string>();
  loadingLabel = input<string>();
  disabled = input(false);
  loading = input(false);

  clicked = output();

  /** bootstrap type: primary, secondary... */
  type = input<string>('primary');
  /** left icon class, E.g: 'bi-arrow-left-short' */
  iconLeft = input<string>();
  /** right icon class, E.g: 'bi-arrow-right-short' */
  iconRight = input<string>();
  /** loading indicator position relative to label */
  loadingIconPosition = input<'left' | 'right'>('right');
  /** button size */
  size = input<'small' | 'normal' | 'large'>('normal');

  onClick() {
    // Emit output
    this.clicked.emit();
  }
}
